import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { HeaderArrowLeftIcon } from './Images';

/**
 *
 * @deprecated вместо navbar используйте header/Header.jsx
 * @returns
 */
function Navbar({
  logo,
  title,
  backUrl,
  backAs,
  phone,
  className,
  logoHeight,
  logoWidth,
}) {
  const logoRenderHeight = 40;
  const logoRenderWidth = logoWidth ? (40 / logoHeight) * logoWidth : 40;

  return (
    <nav
      className={`navbar ${
        backUrl && 'sticky-top p-0 py-md-2'
      } navbar-expand-md navbar-light border-bottom ${className}`}
    >
      <div className="container px-5 flex-nowrap">
        {!backUrl ? (
          <Link
            href="/"
            scroll={false}
            className="navbar-brand me-2"
          >
            {logo ? (
              <div
                className="d-inline-block lh-0 align-middle"
                style={{
                  margin: '-10px 0',
                  height: `${logoRenderHeight}px`,
                  width: `${logoRenderWidth}px`,
                }}
              >
                <Image
                  src={logo}
                  alt={title}
                  height={logoRenderHeight}
                  width={logoRenderWidth}
                  layout="fixed"
                />
              </div>
            ) : (
              <span>{title}</span>
            )}
          </Link>
        ) : (
          <div className="navbar-brand w-100 m-0 pt-0 pt-md-2">
            <div className="row">
              <div className="col">
                {Boolean(backUrl) && (
                <Link
                      href={backUrl}
                      as={backAs}
                      scroll={false}
                      data-testid="modal_back_btn"
                      className="text-decoration-none p-3 ms-n3"
                    >
                      <HeaderArrowLeftIcon />
                    </Link>
                )}
              </div>

              <div className="col-auto">
                <span className="h6">{title}</span>
              </div>

              <div className="col" />
            </div>
          </div>
        )}

        <ul className="navbar-nav ms-auto mb-2 mb-md-0 d-none d-md-flex">
          {Boolean(phone) && (
            <li className="nav-item">
              <Link href={`tel:${phone}`} className="nav-link text-primary py-4 py-md-2" aria-current="page">
                {phone}
              </Link>
            </li>
          )}
        </ul>

      </div>
    </nav>
  );
}

Navbar.propTypes = {
  backUrl: PropTypes.string,
  backAs: PropTypes.string,

  title: PropTypes.string,
  logo: PropTypes.string,
  logoWidth: PropTypes.number,
  logoHeight: PropTypes.number,

  className: PropTypes.string,
};

Navbar.defaultProps = {
  backUrl: '',
  backAs: '',

  title: '',
  logo: null,
  logoWidth: 0,
  logoHeight: 0,

  className: '',
};

export default forwardRef(Navbar);
